(() => {
  const CARD_SELECTOR = '.card-wrapper, .card';
  const IMG_SELECTOR = 'img[data-secondary-image]:not([data-secondary-loaded="true"])';

  function loadSecondary(img) {
    if (!img || img.dataset.secondaryLoaded === 'true') return;

    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.src) img.setAttribute('src', img.dataset.src);

    img.dataset.secondaryLoaded = 'true';
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  }

  function getSecondaryImage(target) {
    const card = target.closest(CARD_SELECTOR);
    if (!card) return null;
    return card.querySelector(IMG_SELECTOR);
  }

  function handlePointerOver(event) {
    const img = getSecondaryImage(event.target);
    if (img) loadSecondary(img);
  }

  function handleFocusIn(event) {
    const img = getSecondaryImage(event.target);
    if (img) loadSecondary(img);
  }

  function handleTouchStart(event) {
    const img = getSecondaryImage(event.target);
    if (img) loadSecondary(img);
  }

  document.addEventListener('pointerover', handlePointerOver, { passive: true });
  document.addEventListener('focusin', handleFocusIn);
  document.addEventListener('touchstart', handleTouchStart, { passive: true });
})();